import { Grid, GridItem } from '@rsa-digital/evo-shared-components/components/Grid';
import RichText from '@rsa-digital/evo-shared-components/components/RichText';
import mediaQuery from '@rsa-digital/evo-shared-components/helpers/mediaQuery';
import spacing from '@rsa-digital/evo-shared-components/helpers/spacing';
import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const RichTextStyle = styled(RichText)`
  padding-top: ${spacing(3)};
  padding-bottom: ${spacing(3)};
  scroll-margin-top: ${spacing(10)};

  ${mediaQuery.tabletLandscape`
    padding-top: ${spacing(4)};
    padding-bottom: ${spacing(4)};
  `}

  h2 {
    margin-top: 0;
    margin-bottom: 0;
    padding-bottom: ${spacing(2)};
  }

  a[href^='mailto:'] {
    word-break: break-all;
  }
`;

export const RichTextGrid = styled(Grid)``;

export const RichTextGridItem = styled(GridItem)``;
